import { render, staticRenderFns } from "./UserProfileClientRefNo.vue?vue&type=template&id=c330bbf8&scoped=true&"
import script from "./UserProfileClientRefNo.vue?vue&type=script&lang=js&"
export * from "./UserProfileClientRefNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c330bbf8",
  null
  
)

export default component.exports